import { toast } from "react-toastify";
import { getApiBaseUrl } from "../../utils/apiBaseUrl";

/**
 * Get the actual image for an address.
 *
 * @param addressId - The ID of the address.
 * @param imageId - The ID of the image.
 * @param token - Authentication token.
 * @param t - Translation function.
 * @returns A promise that resolves to the image Blob.
 */
export async function getAddressImageAsync(
  addressId: number,
  imageId: number,
  token: string,
  t: (key: string) => string
): Promise<Blob | null> {

  if (!navigator.onLine) {
    toast.error(t("internetConnection"), { toastId: "offline-error" });
    return null;
  }

  try {
    const baseUrl = getApiBaseUrl();

    const response = await fetch(
      `${baseUrl}/api/address/GetAddressImageAsync?addressId=${addressId}&imageId=${imageId}`,
      {
        method: "GET",
        headers: {
          "Authorization": `Bearer ${token}`,
        },
      }
    );

    if (!response.ok) {
      const errorData = await response.text();

      throw new Error(
        `Error: ${response.status} ${response.statusText} - ${errorData}`
      );
    }

    const blob = await response.blob();
    return blob;

  } catch (error) {
    throw error;
  }
}